import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { Currency, Rate } from '@zeusm/personal/core/entities';

import { DictionariesApi } from './dictionaries-api.interface';
import { currenciesMock } from '../mocks/currencies.mock';
import { getRatesMock } from '../mocks/rates.mock';

@Injectable()
export class DictionariesApiMockService implements DictionariesApi {
  getCurrencies(): Observable<Currency[]> {
    return of(currenciesMock).pipe(delay(500));
  }

  getRates(): Observable<Rate[]> {
    const rates = getRatesMock();

    return of(rates).pipe(delay(500));
  }
}
